export default __webpack_public_path__ + "assets/images/13b925a6452260f67c204cc6602dd574.png";